<vb-loading-spinner *ngIf="status.loading" [block]="true" [size]="'medium'">
</vb-loading-spinner>

<header class="right-sidebar-content-header" *ngIf="legacyStyle">
	{{'Event_GeneralChat' | translate }}
</header>

<div layout="column" layout-wrap="false" class="height-full">
	<div vbScrollToBottom [ngClass]="styles.commentScroll" flex="1 1 0">
		<div *ngFor="let comment of (chatSource.comments$ | async)" [ngClass]="styles.comment">
			@if (!comment.hidden || comment.hidden && (isEventAdminOrModerator || comment.isAuthoredByCurrentUser)) {
				<div [ngClass]="styles.commentHeader">
					<vb-profile-picture [ngClass]="styles.profilePicture" [profileUrl]="comment.userProfileImageUri">
					</vb-profile-picture>
					<div [ngClass]="styles.commentAuthor">
						<span class="type-bold">{{ comment.name }}</span>
						<span class="type-italic" [ngClass]="styles.commentTime">{{ comment.date | vbTimeShort }} </span>
					</div>
					@if (isEventAdminOrModerator && !comment.isAdminOrModerator) {
						@if (!statusUpdateInProgress) {
							<div dropdown vbDropdown class="menu-wrapper">
								<button type="button" id="moderateCommentBtn" dropdownToggle class="icon-btn">
									<span class="dot"></span><span class="dot"></span><span class="dot"></span>
								</button>

								<div *dropdownMenu class="dropdown dropdown-menu dropdown-menu-right" id="moderateCommentMenu" role="menu" aria-labelledby="moderateCommentBtn">
									<button type="button" class="dropdown-item" (click)="onChangeCommentDisplay(comment)">
										<span>
											{{ (comment.hidden ? 'Event_Chat_ShowMessage' : 'Event_Chat_HideMessage') | translate }}
										</span>
									</button>
									<button type="button" class="dropdown-item" (click)="onDisableAttendeeToComment(comment, !isUserBlocked)">
										@let isUserBlocked = blockedUsers[comment.userId];
										<span>
											{{ (isUserBlocked ? 'Event_Chat_UnblockAttendee' : 'Event_Chat_BlockAttendee') | translate }}
										</span>
									</button>
								</div>
							</div>
						}
						@else {
							<div [ngClass]="styles.commentAction">
								<vb-loading-spinner [size]="'small'" [block]="false">
								</vb-loading-spinner>
								<span class="type-italic padding-left-5"> {{ 'InProgress' | translate }}</span>
							</div>
						}
					}
				</div>
				<div [ngClass]="styles.commentBody">
					@if (comment.hidden && (isEventAdminOrModerator || comment.isAuthoredByCurrentUser)) {
						<p><s [innerHTML]="comment.comment | safeHtml"></s></p>
						@if (comment.isAuthoredByCurrentUser) {
							<div>
								( {{ 'Event_Chat_HiddenMessage' | translate }} )
							</div>
						}
					} @else if (!comment.hidden) {
						<p [innerHTML]="comment.comment | safeHtml"></p>
					}
				</div>
			}
		</div>
	</div>

	<form *ngIf="status.active" #form="ngForm" [ngClass]="styles.chatForm" class="theme-primary-font-border-fade-50" [attr.aria-label]="'Event_Chat_EnterMessage' | translate" (submit)="postComment()" autocomplete="off">

		<vb-ui-html-editor #htmlEditor [attr.aria-label]="'Event_Chat_MessageText' | translate " name="commentText" [(ngModel)]="commentText" (ngModelChange)="onCommentInput()" [editorConfig]="editorConfig" [singleLineMode]="true" [themedToolbarMode]="true" (submit)="postComment()">
		</vb-ui-html-editor>

		<div [ngClass]="styles.chatSubmitWrapper">
			<div>
				@if (blockedUsers.chatAuthorBlocked) {
					{{ 'Event_Chat_AttendeeBlockedMsg' | translate }}
				}

			</div>
			<button type="submit" [disabled]="blockedUsers.chatAuthorBlocked" vbBtnPrimary>
				{{ 'UI_Submit' | translate }}
			</button>
		</div>

	</form>
</div>
